import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  TableCell,
  TableRow,
} from '@material-ui/core';

import Dropdown from '../FormInput/Dropdown';

class EcommDataDropdownRow extends Component {
  render() {
    const {
      canEdit,
      getTabIndex,
      handleChange,
      locationData,
      options,
      rowTitle,
      valueKey,
    } = this.props;

    return (
      <TableRow>
        <TableCell key={`${valueKey}-dropdown`} className="ecommTableLabel">
          <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
            {rowTitle}
          </Box>
        </TableCell>
        {Object.keys(locationData).map((element, index) =>
          <TableCell key={element} className="studioDataRight">
            <Dropdown
              tabIndex={getTabIndex(index)}
              className="studioDataRight studioDataDropdown"
              value={locationData[element][valueKey]}
              name={valueKey}
              disabled={!canEdit}
              options={options}
              onChange={event => handleChange(event, element)}
            />
          </TableCell>
        )}
      </TableRow>
    );
  }
}

EcommDataDropdownRow.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  getTabIndex: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  locationData: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowTitle: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
};
  
export default EcommDataDropdownRow;
